import { Typography } from "@mui/material";
import Box from "@mui/system/Box";
import styled from "styled-components";

export const Container = styled(Box)`
  width: 100%;
  position: absolute;
  bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const CopyrightWrapper = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FooterInfo = styled(Box)`
  width: 100%;
  gap: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FooterTypography = styled(Typography)`
  font-size: 12px;
  color: #718096;
`;
